<button
  type="button"
  class="cta-generic"
  [class.cta-generic--primary]="type === 'primary'"
  [class.cta-generic--secondary]="type === 'secondary'"
  [class.cta-generic--loading]="loading"
  [disabled]="disabled || loading"
  [attr.aria-busy]="loading"
  (click)="onClick()">
  @if (loading) {
    <mat-spinner class="cta-generic__spinner" [diameter]="22" [strokeWidth]="2" [attr.aria-hidden]="true"></mat-spinner>
  } @else if (svgIcon) {
    <mat-icon class="cta-generic__icon" [svgIcon]="svgIcon" aria-hidden="true"></mat-icon>
  } @else if (iconName) {
    <mat-icon class="cta-generic__icon" aria-hidden="true">{{ iconName }}</mat-icon>
  }
  <span class="cta-generic__label">{{ labelKey | translate }}</span>
</button>
